export const UPDATE_I18N = "UPDATE_I18N";